import OfferSimpleView from './OfferSimpleView'

export default OfferSimpleView
